import { z } from "zod";
import { DUB_PARTNER_DATA_COOKIE } from "@common/registrationCookies";
import { getCookie } from "@helpers/cookie";
import { getEnv } from "@lib/environment";

const dubPartnerDataCookieSchema = z.object({
    clickId: z.string(),
    partner: z.object({
        id: z.string(),
        name: z.string().optional(),
        groupId: z.string().optional(),
    }),
});

export function isFreshbooksRegistrationVisitor(): boolean {
    const freshbooksGroupId = getEnv("VITE_FRESHBOOKS_DUB_GROUP_ID");
    if (!freshbooksGroupId) {
        return false;
    }

    const cookie = getCookie(DUB_PARTNER_DATA_COOKIE);
    if (!cookie) {
        return false;
    }

    try {
        const parsed = dubPartnerDataCookieSchema.safeParse(JSON.parse(cookie));
        return (
            parsed.success && parsed.data.partner.groupId === freshbooksGroupId
        );
    } catch {
        return false;
    }
}
